import {MetricValue} from 'common/src/modules/analytics/analytics.types';
import {PERCENT_METRIC_TYPES} from 'common/src/modules/analytics/analytics.constants';

function isPercentageMetric(metric: MetricValue) {
  return PERCENT_METRIC_TYPES.includes(metric);
}

export default isPercentageMetric;
